export class AppSettings {
	public static get APP_NAME(): string {
		return "CAASS10";
	}
	public static get AppErrorPrefix(): string {
		return "CAASS10_Client_ERROR";
	}
	public static get VERSION(): string {
		return "0.0.0";
	}
	public static get PERMISSIONTYPE(): any {
		return {
			accessRead: 1,
			accessUpdate: 2,
			accessInsert: 3,
			accessDelete: 4,
		};
	}
}
